import { render } from "./LogosKnownBy.vue?vue&type=template&id=93d11730&scoped=true&ts=true"
import script from "./LogosKnownBy.vue?vue&type=script&lang=ts"
export * from "./LogosKnownBy.vue?vue&type=script&lang=ts"

import "./LogosKnownBy.vue?vue&type=style&index=0&id=93d11730&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-93d11730"]])

export default __exports__